import React, { Fragment, memo, useCallback, useState } from "react";

import { Cource } from './Cource';
import { NewCource } from './NewCource';

export const CourceList = memo((props) => {
  const { cm, items, filters, options, addCource, removeCource } = props;
  const [isShowText, setIsShowText] = useState(false);

  const onToggleShowText = useCallback((event) => {
    event.preventDefault();
    setIsShowText(!isShowText);
  }, [isShowText]);

  return (
    <>
      <table className="table table-bordered table-hover table-condensed">
          <thead>
            <tr>
            <th style={{ width: 90 + 'px' }}>code</th>
            <th style={{ width: 90 + 'px' }}>並び順</th>
            <th style={isShowText ? { width: 100 + 'px' } : {}}>
              <i className="fas fa-tag" />
              {isShowText ? " (ja)" : " ラベル名/備考(ja)"}
            </th>
            <th style={isShowText ? { width: 100 + 'px' } : {}}>
              <i className="fas fa-tag" />
              {isShowText ? " (en)" : " ラベル名/備考(en)"}
            </th>
              <th>
                <i className="fas fa-pencil-alt" />
                {isShowText ? "" : " 操作"}
              </th>
              <th style={{ width: 320 + 'px' }}>
                <i className="fas fa-filter" />
                {isShowText ? "" : " 選択条件/[生研]オプション設定"}
            </th>
            {isShowText ? 
              <Fragment>
                <th>
                  <a href="#" onClick={(event) => onToggleShowText(event)}>
                    <i className="fas fa-compress-alt" /> Info
                  </a>
                </th>
                <th>
                  <a href="#" onClick={(event) => onToggleShowText(event)}>
                    <i className="fas fa-compress-alt" /> [定形]特記事項
                  </a>
                </th>
              </Fragment>
            :
              <th colSpan="2">
                <a href="#" onClick={(event) => onToggleShowText(event)}>
                  <i className="fas fa-info-circle" />
                </a>
              </th>
            }
            </tr>
        </thead>
        <tbody>
          {items.map(item => 
            <Cource 
              key={item.id} 
              cm={cm} 
              item={item} 
              filters={filters}
              options={options}
              removeCource={removeCource}
              isShowText={isShowText} 
            />
          )}
          <NewCource cm={cm} addCource={addCource} />
        </tbody>
      </table>
    </>
  );
});
